module.exports = __webpack_public_path__ + "static/contact-image-1_d-ad9e3b0f0c1ffc6c84324157bb05fc87.jpg";